module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "order-top",
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('van-cell-group')], 1), _vm._v(" "), _c('div', {
    staticClass: "order-course",
    staticStyle: {
      "width": "7.1rem",
      "margin": "0 auto",
      "background": "#fff",
      "border-radius": "0.2rem",
      "overflow": "hidden"
    }
  }, [_c('van-cell-group', [_c('van-cell', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "600"
    },
    attrs: {
      "title": "课程信息",
      "value": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "course-info-box"
  }, [_c('div', {
    staticClass: "course-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.row.course_data.pic_url,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "course-info"
  }, [_c('p', {
    staticClass: "info-title"
  }, [_vm._v(_vm._s(_vm.row.course_data.title))]), _vm._v(" "), _c('p', {
    staticClass: "info-main"
  }, [_vm._v("视频 " + _vm._s(_vm.row.course_data.video_count))]), _vm._v(" "), _c('div', {
    staticClass: "info-bottom"
  }, [_c('span', {
    staticClass: "course-price"
  }, [_vm._v("¥" + _vm._s(_vm.row.course_data.price))]), _vm._v(" "), _c('span', {
    staticClass: "course-day"
  }, [_vm._v("有效期 " + _vm._s(_vm.row.course_data.pay_days) + "天")])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "order-pay-btn"
  }, [_c('div', {
    staticClass: "online-pay",
    on: {
      "click": _vm.onPay
    }
  }, [_vm._v("在线支付开通")])]), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  }), _vm._v(" "), _c('PayDialog', {
    attrs: {
      "show": _vm.payDialogShow,
      "scene": "course",
      "ids": _vm.orderIds
    },
    on: {
      "onPayError": _vm.onPayError,
      "onPaySuccess": _vm.onPaySuccess,
      "onPayClose": _vm.onPayClose
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64abc779","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/course/CourseOrderCheck.vue
// module id = 2430
// module chunks = 0